import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Contact from "./pages/Contact";
import Verify from "./pages/Verify";
import "./App.css";

function App(){
  return(
    <BrowserRouter>

      <div className="app-container">

        <Header/>

        {/* page content */}
        <div className="page-content">
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/about" element={<About/>}/>
            <Route path="/courses" element={<Courses/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="/verify" element={<Verify/>}/>
          </Routes>
        </div>

        <Footer/>

      </div>

    </BrowserRouter>
  )
}

export default App;